export default [
  {id: 'r1', name: 'Remolque de menos de 4 metros', value: 0},
  {id: 'r2', name: 'Remolque de 4,01 metros a 6,50 metros', value: 1},
  {id: 'r3', name: 'Remolque de 6,51 metros a 7,50 metros', value: 2},
  {id: 'r4', name: 'Remolque de más de 7,51 metros', value: 3},
]



// WEBPACK FOOTER //
// ./src/shared/routers/languages/es/arrays/towings.js